var _defs, _rect, _rect2, _rect3, _g, _g2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzVideoHeroLuminousBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz video hero luminous background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "tlvhGlowBlue",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(1110 315) rotate(90) scale(510 650)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#087CFF",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tlvhGlowPink",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(1280 700) rotate(90) scale(420 500)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3885",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF3885",
    stopOpacity: 0.045
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3885",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tlvhBase",
    x1: 0,
    y1: 0,
    x2: 1440,
    y2: 900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#06142A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030A19"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "url(#tlvhBase)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "url(#tlvhGlowBlue)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "url(#tlvhGlowPink)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#5BA9FF",
    strokeOpacity: 0.12
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1130,
    cy: 350,
    r: 238
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130,
    cy: 350,
    r: 315
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130,
    cy: 350,
    r: 395
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#8AC6FF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 815,
    cy: 178,
    r: 2,
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 79,
    r: 1.5,
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1365,
    cy: 286,
    r: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 688,
    r: 1.5,
    opacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M713 724C917 611 1114 668 1440 524",
    fill: "none",
    stroke: "#FF5C9A",
    strokeOpacity: 0.11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M760 775C1032 633 1191 738 1440 635",
    fill: "none",
    stroke: "#5BA9FF",
    strokeOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzVideoHeroLuminousBackground);
export default __webpack_public_path__ + "static/media/talentlenz-video-hero-luminous-background.ff4e8eca00b442ebef726524aa14c37c.svg";
export { ForwardRef as ReactComponent };